<template>
  <div class="container mx-auto py-2 px-2">

    <p class="title-font-weight mt-5"><span class="title-text">PERÍODO</span> <span class="title-text-en">PERIOD</span></p>
    <div class="periods flex flex-wrap lg:justify-between mt-2 mb-10">
      <Period v-for="p in periods" :key="p.id" :period="p" :active="isPeriodSelected(p)" @click.native="periodClick(p)" class="cursor-pointer"/>
    </div>

    <p class="title-font-weight mt-5 mb-2"><span class="title-text">ANO</span> <span class="title-text-en">YEAR</span></p>
    <div class="years flex flex-wrap mb-16">
      <Year v-for="y in years" :key="y" :year="y" :active="isYearSelected(y)" @click.native="yearClick(y)" class="cursor-pointer"/>
    </div>

    <div class="hidden md:block">
      <div class="flex mt-5" style="">
        <div class="mr-2" style="flex: 0 0 33.333333%;">
          <p class="title-font-weight"><span class="title-text">DEPUTADO</span> <span class="title-text-en">MP</span></p>
          <div class="authors mt-6">
            <Author v-for="a in authors" :key="a.id" :author="a" :active="isAuthorSelected(a)" @click.native="authorClick(a)" class="cursor-pointer"/>
          </div>
        </div>
        <div class="ml-2" style="flex: 0 0 66.666666%;">
          <p class="title-font-weight"><span class="title-text">EDIÇÃO</span> <span class="title-text-en">PUBLICATION</span></p>
          <div class="publications mt-6">
            <Publication v-for="p in publications" :key="p.id" :publication="p" :active="selectedAuthor !== undefined"/>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 md:hidden">
      <p class="title-font-weight"><span class="title-text">DEPUTADO</span> <span class="title-text-en">MP</span></p>
      <div class="authors mt-6">
        <div v-for="a in authors" :key="a.id">
          <Author :author="a" :active="isAuthorSelected(a)" @click.native="authorClick(a)" class="cursor-pointer"/>
          <div class="ml-10 mb-10" v-if="isAuthorSelected(a)">
            <Publication v-for="p in publications" :key="p.id" :publication="p" :active="true"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import periods from '@/data/periods.json';
import authors from '@/data/authors.json';
import publications from '@/data/publications.json';
import authorsPublications from '@/data/authorsPublications.json';
import Period from "@/components/Period";
import Year from "@/components/Year";
import Author from "@/components/Author";
import Publication from "@/components/Publication";

// TODO https://github.com/DJanoskova/Vuidget
// TODO https://itnext.io/vuidget-how-to-create-an-embeddable-vue-js-widget-with-vue-custom-element-674bdcb96b97
// TODO https://cli.vuejs.org/guide/deployment.html#general-guidelines

export default {
  name: 'Home',
  metaInfo: {
    title: "AR"
  },
  components: {Publication, Author, Year, Period},
  props: {
    periodId: {
      type: String,
      require: true
    },
  },
  data: () => ({
    periods,
    selectedPeriod: undefined,
    selectedYear: undefined,
    selectedAuthor: undefined,
    authorsWPublications: undefined
  }),
  created() {
    this.initPeriod(this.periodId)

    this.authorsWPublications = authors.map(a => {
      const publicationsIds = authorsPublications.filter(ap => ap.author_id === a.id).map(ap => ap.publication_id)
      a.publications = publications.filter(p => publicationsIds.includes(p.id))
      return a
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.initPeriod(to.params.periodId)
    next();
  },
  computed: {
    years() {
      let years = []
      for (let i = this.selectedPeriod.start_year; i <= this.selectedPeriod.end_year; i++) {
        if (this.checkYearInSelectedPeriod(i) && publications.find(p => p.edition_year === i)) {
          years.push(i)
        }
      }
      return years
    },
    authors() {
      if (this.selectedYear !== undefined) {
        return this.authorsWPublications.filter(a => a.publications.find(p => p.edition_year === this.selectedYear) !== undefined)
      } else {
        return this.authorsWPublications.filter(a => a.publications.find(p => this.checkYearInSelectedPeriod(p.edition_year)) !== undefined)
      }
    },
    publications() {
      if (this.selectedYear !== undefined && this.selectedAuthor !== undefined) {
        return this.selectedAuthor.publications.filter(p => p.edition_year === this.selectedYear)
      } else if (this.selectedAuthor !== undefined) {
        return this.selectedAuthor.publications.filter(p => this.checkYearInSelectedPeriod(p.edition_year))
      } else if (this.selectedYear !== undefined) {
        return publications.filter(p => p.edition_year === this.selectedYear)
      } else {
        return publications.filter(p => this.checkYearInSelectedPeriod(p.edition_year))
      }
    }
  },
  methods: {
    initPeriod(periodId) {
      periodId = parseInt(periodId)
      this.selectedPeriod = periods.find(p => p.id === periodId)
      if (this.selectedPeriod === undefined) {
        this.$router.push("/");
      }
      this.selectedYear = undefined
      this.selectedAuthor = undefined
    },
    checkYearInSelectedPeriod(year) {
      const start = this.selectedPeriod.exclude_start_year ? this.selectedPeriod.start_year + 1 : this.selectedPeriod.start_year
      const end = this.selectedPeriod.exclude_end_year ? this.selectedPeriod.end_year - 1 : this.selectedPeriod.end_year
      return year >= start && year <= end
    },
    periodClick(period) {
      const to = "/" + period.id
      if (this.$router.currentRoute.path !== to) {
        this.$router.push(to)
      }
    },
    isPeriodSelected(period) {
      return this.selectedPeriod !== undefined && this.selectedPeriod.id === period.id
    },
    yearClick(year) {
      this.selectedYear = this.selectedYear !== year ? year : undefined;
      if (this.selectedAuthor !== undefined &&
          this.selectedAuthor.publications.find(p => p.edition_year === year) === undefined) {
        this.selectedAuthor = undefined
      }
    },
    isYearSelected(year) {
      return this.selectedYear === year
    },
    authorClick(author) {
      this.selectedAuthor = this.selectedAuthor === undefined || this.selectedAuthor.id !== author.id ? author : undefined;
    },
    isAuthorSelected(author) {
      return this.selectedAuthor !== undefined && this.selectedAuthor.id === author.id
    }
  }
}
</script>
